<template>
  <div class="page-content">
    <div class="page-box">
      <div class="page-box-content" v-if="user">
        <div class="scoped-header">
          <div class="money" v-if="!user.hide_money">{{ user.money | money }}  <Tag type="border" color="primary">{{ $t('name.user.money_day_text')[user.money_day] }}</Tag></div>
          <div class="name">{{ user.name }}</div>
          <div class="username">
            {{ $t('name.user.username') }}: {{ user.username }} <Divider type="vertical" />
            {{ $t('name.user.number') }}: {{ user.number }} <Divider type="vertical" />
            {{ $t('name.user.type') }}: {{ $t('name.user.type_text')[user.type] }}
          </div>
        </div>
      </div>
    </div>
    <Form ref="form" :model="user" :rules="rule">
      <Row :gutter="30">
        <Col :span="6">
          <div class="page-box">
            <div class="page-box-content" v-if="user">
              <FormItem :label="formName" prop="name">
                <Input v-model="user.name" />
              </FormItem>
              <FormItem :label="formPhone" prop="phone">
                <Input v-model="user.phone" />
              </FormItem>
              <FormItem :label="formEmail" prop="email">
                <Input v-model="user.email" />
              </FormItem>
              <FormItem :label="formCode">
                <Input v-model="user.code" />
              </FormItem>
              <FormItem :label="$t('name.user.password')">
                <Input v-model="user.password"/>
              </FormItem>
            </div>
          </div>
        </Col>
        <Col :span="18">
          <div class="page-box">
            <div class="page-box-content" v-if="user">
              <Row :gutter="30">
                <Col span="6">
                  <FormItem :label="$t('name.user.country')">
                    <Input v-model="user.country"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.city')">
                    <Input v-model="user.city"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.area')">
                    <Input v-model="user.area"/>
                  </FormItem>
                </Col>
                <Col :span="6">
                  <FormItem :label="$t('name.user.zip')">
                    <Input v-model="user.zip"/>
                  </FormItem>
                </Col>
              </Row>
              <Row :gutter="30">
                <Col span="18">
                  <FormItem :label="$t('name.user.address')">
                    <Input v-model="user.address"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.address_code')">
                    <Input v-model="user.address_code"/>
                  </FormItem>
                </Col>
              </Row>
              <Divider style="margin: 22px 0" />
              <Row :gutter="30">
                <Col span="6">
                  <FormItem :label="$t('name.user.bank')">
                    <Input v-model="user.bank"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.bank_name')">
                    <Input v-model="user.bank_name"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.bank_code')">
                    <Input v-model="user.bank_code"/>
                  </FormItem>
                </Col>
                <Col :span="6">
                  <FormItem :label="$t('name.user.ticket')">
                    <div style="width: 100%; display: inline-block;">
                      <Tag :color="user.ticket ? 'warning' : 'default'">{{ $t('name.user.ticket_text')[user.ticket] }}</Tag>
                    </div>
                  </FormItem>
                </Col>
              </Row>
              <Divider style="margin: 22px 0" />
              <Row :gutter="30">
                <Col span="6">
                  <FormItem :label="$t('name.user.cex_level')">
                    <div style="width: 100%; display: inline-block;">
                      <Tag v-if="user.cex_level_id" color="primary">{{ user.cex_level.name }}</Tag>
                    </div>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.cex_codigo')">
                    <Input v-model="user.cex_codigo"/>
                  </FormItem>
                </Col>
                <Col span="6">
                  <FormItem :label="$t('name.user.cex_pdf_type')">
                    <Select v-model="user.cex_pdf_type">
                      <Option :value="1">{{ $t('name.user.cex_pdf_type_text')[1] }}</Option>
                      <Option :value="3">{{ $t('name.user.cex_pdf_type_text')[3] }}</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </Form>
    <Button type="primary" size="large" :loading="loading" @click="update" long>{{ $t('name.confirm') }}</Button>
  </div>
</template>
<script>
import { info } from '@/api/auth';
import { update } from '@/api/user';

export default {
  computed: {
    formName() {
      return this.$t('name.user.type_data')[this.user.type].name
    },
    formPhone() {
      return this.$t('name.user.type_data')[this.user.type].phone
    },
    formEmail() {
      return this.$t('name.user.type_data')[this.user.type].email
    },
    formCode() {
      return this.$t('name.user.type_data')[this.user.type].code
    }
  },
  data() {
    return {
      loading: false,
      user: null,
      rule: {
        name: [
          { required: true, message: ' ', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      },
    }
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      info().then(res => {
        this.user = res
      })
    },
    // 更新资料
    update() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          update(this.user).then(res => {
            this.loading = false
            this.$Message.success(this.$t('message.' + res.message))
          })
        }
      })
    }
  },
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-header{
    color: @color-content;
    
    .name{
      font-size: 20px;
      line-height: 30px;
    }
    .username{
      font-size: 14px;
      line-height: 25px;
      color: @color-sub;
    }
    .money{
      font-size: 30px;
      line-height: 55px;
      color: @color;
      float:right;
    }
  }
  .scoped-form{
    display: flex;
  }
  .scoped-left{
    width: 350px;
    padding-right: 30px;
    border-right: 1px #e8eaec solid;
  }
  
  .scoped-right{
    flex-grow: 1;
    padding-left: 30px;
  }
</style>